import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';

const INITIAL_STATE = {
  'loading': false,
  'url': '',
};

export const partsLocationDashboard = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PARTS_LOCATION_DASHBOARD]: (state, action) => ({
      ...state,
      'loading': true,
      'url': '',
    }),
    [ActionTypes.FETCHED_PARTS_LOCATION_DASHBOARD]: (state, action) => ({
      ...state,
      'loading': false,
      'url': action.response.data,
    }),
    [ActionTypes.FETCHED_PARTS_LOCATION_DASHBOARD_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'url': '',
    }),
  })(state, action);
};
